import React, {useState, useEffect} from "react";
import { Link } from "react-router-dom";

import LeftMenuLayout from '../layouts/LeftMenuLayout';

import classNames from 'classnames';
import * as Yup from 'yup';
import { Formik } from 'formik';

import {Loading} from "../custom-icons";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedin } from "react-icons/fa";
import axios from 'axios';  

import {APP_URL, APP_NAME , IMG_URL, API_ENDPOINT, toast_anim , pdfdoconly , hospital_regOptions} from '../components/config/Common'
import Helmet from 'react-helmet'
import { ReactSEOMetaTags } from 'react-seo-meta-tags'
import { toast } from 'react-toastify';
import ScrollPageTop from '../routes/ScrollPageTop'

import { yupResolver } from '@hookform/resolvers/yup';
import Input from '../ui/input.jsx'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/bootstrap.css'
import SelectInput from '../ui/select-input.jsx'
import Label from '../ui/label.tsx'
import Button from '../ui/Button.tsx'
import TextArea from '../ui/text-area.tsx'

import {
    Control,
    FieldErrors,
    useForm,
    useFormState,
    useWatch,
    Controller
 } from 'react-hook-form';

const SignupSchema = Yup.object().shape({
    product_name: Yup.string()
        .required('You must need to provide Product Name.'),
    sku: Yup.string()
        .required('You must need to provide Product SKU.'),
    message: Yup.string()
        .required('You must need to provide message.'),		
});

let defaultValues = {  
	product_name: '',
	sku: '',
	message: '',
	email:'',
	phone_no:'',
	name:'',
};

const ProductEnquiry = () => {

    const [access_token, setAccess_token] = useState(localStorage.getItem('access_token'))
    const [user_type, setUser_type] = useState(localStorage.getItem('user_type'))
    const [user_me, setUser_me] = useState(null);
    const [loading, setLoading] = useState(false);

    const { register, handleSubmit , control, reset, setValue, setError, formState: { errors },} = useForm({
            defaultValues: defaultValues,
            resolver: yupResolver(SignupSchema),
        });

    useEffect(() => {
        getMyProfile()
            
    },[])

    const onSubmit = (values) => {
		//console.log('value===', values)

        let input = {
            product_name: values.product_name,
            sku: values.sku,
            message: values.message,
            user_id: user_me.id,
        }

        //console.log('input===', input)

        setLoading(true)
        axios.post(`${API_ENDPOINT}/product_enquiry_by_hospital`, input, {
            headers : {        
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer '+access_token, 
            }
        }).then(function (response) {
                setLoading(false)
                //console.log('response===', response)
                toast.success(response.data.message, toast_anim);
                reset(defaultValues)
        }).catch(function (error) {
            setLoading(false)
            if(error.response){
                if(error.response.status === 422){
                    let errors = error.response.data.errors
                    for (const key in errors) {
                        if (errors.hasOwnProperty(key)) {
                            setError(key, { type: 'server', message: errors[key][0] });
                        }
                    }
                    setError('sku', { type: 'server', message: error.response.data.message });
                    toast.error(error.response.data.message, toast_anim);
                }else{
                    toast.error(error.response.data.message, toast_anim);
                }
            }else{
                toast.error('Something went wrong. Please try again.', toast_anim);
            }
        });
	}

    const getMyProfile = () => {
        //console.log(this.state.access_token)
        fetch(`${API_ENDPOINT}/user_me`,{
            method: 'GET',
            headers : {        
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer '+access_token, 
            }
        }).then(function (response) {
                return response.json();
        }).then( (result)=> {
            //console.log('result===', result)
            setUser_me(result.data)
            let data = result.data
        })
    }	

    const siteMetadata = {
        url: `${APP_URL}/product-enquiry`,
        title:  `Product Enquiry - ${APP_NAME}`,
        description: `Product Enquiry ctmrihub`,
    };

    return (
		<ScrollPageTop>
			<ReactSEOMetaTags
				render={(el: React.ReactNode) => <Helmet>{el}</Helmet>}
				website={{ ...siteMetadata }}
				breadcrumb={[
					{ title: 'Home', url: `${APP_URL}` },
					{ title: 'Product Enquiry', url: `${APP_URL}/product-enquiry` },
				]}
			/>
         <LeftMenuLayout>
            <div className="w-full">
                <div className={classNames('w-full p-5 md:p-8 bg-light dark:bg-gray-700 shadow rounded mb-8')}>
                    <p className="text-lg lg:text-xl text-heading capitalize mb-5 dark:text-zinc-400">Product Enquiry</p>
                    
                    <form onSubmit={handleSubmit(onSubmit)}>
                    
                        <Input                
                            label={`Product Name`}
                            {...register('product_name')}
                            variant="outline"
                            className="mb-5"
                            type="text"
                            error={errors.product_name?.message}
                            required
                        />
                
                        <Input                
                            label={`Product SKU`}
                            {...register('sku')}
                            variant="outline"
                            className="mb-5"
                            type="text"
                            error={errors.sku?.message}
                            required
                        />
                        <TextArea
                            label={`Message`}
                            {...register('message')}
                            variant="outline"
                            className="mb-5"
                            error={errors.message?.message}
                            required
                        />
                        <Button loading={loading} type="submit" className="w-full md:w-auto">Submit Enquiry</Button>  
                    
                    </form>
                </div>
            </div>
         </LeftMenuLayout>
        </ScrollPageTop>
    );

}

export default ProductEnquiry;